function cleanNumberedChoiceLabel(raw) {
  let label = String(raw || "")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/[.。]\s*$/, "");
  if (label.length > 140) label = `${label.slice(0, 139).trim()}…`;
  return label;
}

export function extractNumberedChoiceLabels(text) {
  const raw = String(text || "");
  const byIndex = [];

  const parenRe = /(?:^|\n)\s*\(([1-6])\)\s+([^\n]+)/g;
  let match;
  while ((match = parenRe.exec(raw))) {
    const label = cleanNumberedChoiceLabel(match[2]);
    if (label.length >= 8) byIndex[Number(match[1]) - 1] = label;
  }

  if (byIndex.filter(Boolean).length < 3) {
    const lineRe = /(?:^|\n)\s*([1-6])[.)]\s+([^\n]{8,})/g;
    while ((match = lineRe.exec(raw))) {
      const idx = Number(match[1]) - 1;
      if (byIndex[idx]) continue;
      const label = cleanNumberedChoiceLabel(match[2]);
      if (label.length >= 8) byIndex[idx] = label;
    }
  }

  const labels = [];
  for (let i = 0; i < 6; i += 1) {
    if (!byIndex[i]) break;
    labels.push(byIndex[i]);
  }
  return labels.length >= 3 ? labels : [];
}

/**
 * When Digiping writes numbered choices in the question, show those labels
 * (same language as the question) instead of canned chips from another locale.
 */
export function overlayNumberedProfilingChips(canned, questionText) {
  const options = Array.isArray(canned) ? canned : [];
  const labels = extractNumberedChoiceLabels(questionText);
  if (labels.length < 3) return options;
  if (
    options.length &&
    options.every((opt) => /^\d+$/.test(String(opt?.label || opt?.value || "")))
  ) {
    return options;
  }
  return labels.map((label, index) => ({
    ...(options[index] || { value: String(index + 1) }),
    label,
  }));
}

export function shouldOverlayProfilingChips(prompt) {
  const questionType = String(prompt?.questionType || "");
  return questionType !== "exercise_choice" && questionType !== "conversation_offer";
}
